import Conversation from './components/Conversation';
import styles from './thread.module.scss';
import ThreadOptions from './components/ThreadOptions';
import Disclaimer from '@/components/Disclaimer';
import { SidebarProvider } from './context/SidebarProvider';
import SEOHelmet from '@/components/SEOHelmet';
import useThread from './hooks/useThread';
import Sidebar from './components/Sidebar';
import InputBox from '@/components/InputBox';

const Thread = () => {
  const { id, title, status } = useThread();
  return (
    <div className={styles['thread-wrapper']}>
      <SEOHelmet title={id ? `🧵 ➤ ${title}` : 'New Thread'} />
      <SidebarProvider>
        <section className={styles['thread-main']}>
          <ThreadOptions />
          <Conversation />
          {status !== 'ERROR' && <InputBox />}
          <Disclaimer />
        </section>
        <Sidebar />
      </SidebarProvider>
    </div>
  );
};

export default Thread;
